import { IsNotEmpty } from 'class-validator';

export class UpdateEngagementStatusDto {
	_id: string;

	@IsNotEmpty({ message: 'Name is required' })
	statusName: string;

	@IsNotEmpty({ message: 'Color is required' })
	color: string;

	isDefaultStatus: boolean;
}
